(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name individualFlyingHours.controller:IndividualFlyingHoursCtrl
   *
   * @description
   *
   */
  angular
    .module('individualFlyingHours')
    .controller('IndividualFlyingHoursCtrl', IndividualFlyingHoursCtrl);

  function IndividualFlyingHoursCtrl(CommonMasterData, $sce,CommonLogicService, crewScheduleService) {
    var vm = this;
    vm.ctrlName = 'IndividualFlyingHoursCtrl';
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        crewType : null,
        crewName : null,
        crewId : null
      },
      masterList : {
        crewTypes : [],
        crewList : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        isToDateFutureDate : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };
    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchIndividualFlyingHours(params);
    };

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.isToDateFutureDate) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if (flag == 'crewType') {
        vm.model.searchCriteria.crewName = null;
        if (!!vm.model.searchCriteria.crewType
          && !!vm.model.searchCriteria.crewType.crewTypeCode) {
          loadCrewList(vm.model.searchCriteria.crewType.crewTypeCode);
        } else {
          vm.model.masterList.crewList = [];
        }
      } else if (flag == 'crewName') {
        if (!!vm.model.searchCriteria.crewName) {
          vm.model.searchCriteria.crewId = vm.model.searchCriteria.crewName.crewId;
        }
      } else if (flag == 'crewId') {
        vm.model.searchCriteria.crewType = null;
        vm.model.searchCriteria.crewName = null;
        vm.model.masterList.crewList = [];
      }
    };

    // load crew list
    function loadCrewList(crewType) {

      var param = {};
      param.crewType = crewType;
      param.active = true;
      CommonMasterData.loadCrewList(param, function(response) {
        vm.model.masterList.crewList = crewScheduleService
          .adaptCrewList(response);
        vm.model.searchCriteria.crewName = null;
      }, function() {
        console.log('Crew list retrieval error');
      });

    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.isToDateFutureDate = false;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
        if (!!vm.model.searchCriteria.toDate) {
          vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
        } else {
          vm.model.masterList.isToDateFutureDate = false;
        }
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    // check to date is a future date
    function istoDateFutureDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isAfter(moment().toDate());
    };

    // search Training Allowance Report
    function searchIndividualFlyingHours(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var url = CommonLogicService.getReportUrl(
          'individual_flying_hours.rptdesign',
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);

      }
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      if (!!param.crewId) {
        searchParamMap["crewId"] = param.crewId;
      }
      return searchParamMap;
    }
    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid
        || vm.model.masterList.isToDateFutureDate) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        return true;
      }
    }

    ( // load crew Types
      function loadCrewTypes() {
        CommonMasterData.getCrewTypeList(function(crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
        }, function() {
          console.log('Crew type retrieval error');
        });
      })();
  }
}());
